
import { defineComponent, ref } from 'vue';
import MoveItemConfirm from '@/components/BottomPopUp/PopUpTypes/MoveTo/MoveItemConfirm.vue';

export default defineComponent({
  emits: ['cancel', 'new-folder', 'move'],
  props: {
    disabledMove: { type: Boolean, default: false },
    isShared: { type: Boolean, default: false },
  },
  components: {
    // MoveItemConfirm,
  },
  setup(props, { emit }) {
    const isMoving = ref(false);
    function moveItem() {
      isMoving.value = false;
      if (props.disabledMove) {
        return;
      }
      emit('move');
    }
    function handleMove() {
      if (!props.disabledMove) {
        isMoving.value = true;
      }
    }

    return {
      isMoving,
      moveItem,
      handleMove,
    };
  },
});
